var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-tab', {
    staticClass: "mt-5",
    attrs: {
      "title": "Documentos",
      "active": _vm.isTheCurrentTab,
      "disabled": !_vm.isTheCurrentTab
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "10"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "numero_nfe",
      "label-for": "numero_nfe",
      "label": "Número NFe"
    }
  }, [_c('VueSelect', {
    ref: "numero_nfe",
    attrs: {
      "filterable": false,
      "options": _vm.searchedNfes
    },
    on: {
      "search": _vm.onSearchNfe
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.numero) + " - " + _vm._s(option.nomeCliente) + " - " + _vm._s(option.chave) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.numero) + " - " + _vm._s(option.nomeCliente) + " - " + _vm._s(option.chave) + " ")])];
      }
    }]),
    model: {
      value: _vm.selectedNFe,
      callback: function callback($$v) {
        _vm.selectedNFe = $$v;
      },
      expression: "selectedNFe"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Digite o número da NFe para buscar ")])], 2)], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "label-for": "add"
    }
  }, [_c('button', {
    on: {
      "click": function click($event) {
        return _vm.addNfe(_vm.selectedNFe);
      }
    }
  }, [_vm.windowWidth > 768 ? _c('Plus', {
    staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2 mt-9"
  }) : _c('button', {
    staticClass: "btn btn-info btn-hover-dark font-weight-bolder font-size-lg ml-2"
  }, [_vm._v(" Adicionar produto ")])], 1)])], 1)], 1), _c('b-row', [_c('b-col', [_c('TableApp', {
    ref: "nome",
    attrs: {
      "item": "produto",
      "subTitulo": "",
      "data": _vm.documentosVinculados,
      "fields": _vm.fields,
      "classFilterColumn": "nome"
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'numero' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "nome"
          },
          slot: "nome"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(props.rowData.numero) + " ")])])]) : _vm._e(), props.field == 'chave' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "quantidade"
          },
          slot: "quantidade"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(props.rowData.chave) + " ")])])]) : _vm._e(), props.field == 'actions' ? _c('span', {
          attrs: {
            "slot": "actions"
          },
          slot: "actions"
        }, [_c('div', {
          staticClass: "row-actions",
          staticStyle: {
            "text-align": "right !important"
          }
        }, [_c('span', {
          staticStyle: {
            "overflow": "visible",
            "position": "relative",
            "width": "130px"
          }
        }, [_c('div', {
          staticClass: "action-buttons"
        }, [_c('button', {
          staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.handleDeleteNfe(props.rowData);
            }
          }
        }, [_c('TrashCanIcon', {
          attrs: {
            "size": 16
          }
        })], 1)])])])]) : _vm._e()];
      }
    }])
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };